var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("path", {
    attrs: {
      "fill-rule": "evenodd",
      d:
        "M73.025.687C64.812.456 18.127 2.556 9.74 12.382-1.971 26.1-1.784 44.573 7.669 53.732c10.975 10.634 49.525 15.06 59.193 15.333 6.313.178 48.188 2.717 60.453-7.247 8.614-6.998 8.435-25.225-.397-39.754C118.2 6.074 78.584.844 73.025.687z"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32254aaa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32254aaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_SVG/ShapeYearBtn2Mob.vue
// module id = l1rK
// module chunks = 1